(function () {
  if (window.tbProductGalleryArrowsLoaded) return;
  window.tbProductGalleryArrowsLoaded = true;

  document.addEventListener(
    "click",
    function (event) {
      const arrow = event.target.closest(
        '[id^="GalleryViewer-"] .slider-button--prev, ' +
        '[id^="GalleryViewer-"] .slider-button--next'
      );

      if (!arrow) return;

      const gallery = arrow.closest("media-gallery");
      if (!gallery) return;

      // Evitamos que el slider nativo intente hacer scroll.
      event.preventDefault();
      event.stopPropagation();

      const thumbnailItems = Array.from(
        gallery.querySelectorAll(
          '[id^="GalleryThumbnails-"] .thumbnail-list__item'
        )
      ).filter(function (item) {
        // Ignora imágenes ocultas por variantes.
        return item.offsetParent !== null;
      });

      const thumbnails = thumbnailItems
        .map(function (item) {
          return item.querySelector("button.thumbnail");
        })
        .filter(Boolean);

      if (thumbnails.length < 2) return;

      // Detectar cuál imagen principal está activa.
      const activeMedia = gallery.querySelector(
        '[id^="Slider-Gallery-"] .product__media-item.is-active'
      );

      let currentIndex = -1;

      if (activeMedia && activeMedia.dataset.mediaId) {
        currentIndex = thumbnailItems.findIndex(function (item) {
          return item.dataset.target === activeMedia.dataset.mediaId;
        });
      }

      // Respaldo: usar aria-current de la miniatura.
      if (currentIndex < 0) {
        currentIndex = thumbnails.findIndex(function (thumbnail) {
          return thumbnail.getAttribute("aria-current") === "true";
        });
      }

      if (currentIndex < 0) currentIndex = 0;

      const isNext = arrow.classList.contains("slider-button--next");

      let newIndex;

      if (isNext) {
        newIndex = (currentIndex + 1) % thumbnails.length;
      } else {
        newIndex =
          (currentIndex - 1 + thumbnails.length) % thumbnails.length;
      }

      // Utilizamos la lógica nativa del tema.
      thumbnails[newIndex].click();
    },
    true
  );
})();